import {Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ModalController, NavParams, Platform} from '@ionic/angular';
import {ScreenOrientation} from '@ionic-native/screen-orientation/ngx';
import {Subscription} from 'rxjs';
import {HelperService} from '../../service/helper.service';
import {ApiService} from "../../service/api.service";

@Component({
    selector: 'app-bxh',
    templateUrl: './bxh.component.html',
    styleUrls: ['./bxh.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class BxhComponent implements OnInit, OnDestroy {
    @ViewChild('bxhTXCB', {static: false}) elBxhTXCB: ElementRef;
    arrTopTen = [];
    subscriptionScreenOri: Subscription;
    isLandscape = false;

    constructor(
        private modalCtr: ModalController,
        private navParams: NavParams,
        private hpService: HelperService,
        protected apiService: ApiService,
        private screenOrientation: ScreenOrientation,
        public platform: Platform
    ) {
        this.arrTopTen = navParams.data.dataBxh.filter(item => item.amount && item.amount > 0).sort((a, b) => b.amount - a.amount).slice(0, 10);

        platform.ready().then((readySource) => {
            this.detectScreenOrient();
        });
        this.subscriptionScreenOri = screenOrientation.onChange().subscribe(
            () => {
                this.detectScreenOrient();
            }
        );
    }

    detectScreenOrient() {
        setTimeout(() => {
            const pH = this.platform.height();
            const pW = this.platform.width();
            let hGame = 0;
            if (pW > pH) {
                this.isLandscape = true;
                hGame = 305;
            } else if (pW < pH) {
                this.isLandscape = false;
                hGame = 400;
            }

            if (pH < hGame) {
                this.elBxhTXCB.nativeElement.style.transform = `scale(${(pH / hGame)})`;
            } else {
                this.elBxhTXCB.nativeElement.style.transform = `scale(1)`;
            }
        }, 100);
    }

    ngOnInit() {}

    ngOnDestroy(): void {
        this.subscriptionScreenOri.unsubscribe();
    }

    async closeModal() {
        await this.modalCtr.dismiss();
    }
}
